import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, } from '@angular/core';
import { ToolbarButtonComponent } from '../toolbar-button/toolbar-button.component';

@Component({
    selector: 'app-go-to-parent-slide-button',
    templateUrl: './go-to-parent-slide-button.component.html',
    styleUrls: ['./go-to-parent-slide-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ToolbarButtonComponent]
})
export class GoToParentSlideButtonComponent {
    @Input() disabled = true;
    @Output() goToParentClicked = new EventEmitter<void>();

    onButtonClicked() {
        if (!this.disabled) {
            this.goToParentClicked.emit();
        }
    }
}
